<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: [String, Number, Array],
            label: String,
            labelWidth: String,
            labelValue: [String, Number],
            labelOptions: Array,
            labelField: String,
            labelDisabled: {
                type: Boolean,
                default: false,
            },
            add: {
                type: Boolean,
                default: false,
            },
            list: {
                type: Array,
                default() {
                    return [];
                }
            },
            field: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: ''
            }
        },
        methods: {
            change_value(v) {
                this.$emit('input', v);
                this.$emit('change', v);
                if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            change_label(v) {
                this.$emit('update:labelValue', v);
                this.$emit('change-label', v);
                if (this.labelField) {
                    this.$emit('change-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_label(v) {
                this.$emit('update:labelValue', v);
                if (this.labelField) {
                    this.$emit('input-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            click_add() {
                this.$emit('add');
            },
        },
        computed: {
            show_append() {
                return this.show_remove||this.show_add;
            },
            show_remove() {
                if (this.disabled) return false;
                if (!this.multiple) return false;
                if (this.value && !this.value.length) {
                    return false;
                }
                return true;
            },
            show_add() {
                if (this.disabled) return false;
                return this.add;
            },
        },
        watch: {},
        mounted() {
        },

        components: {},
    }
</script>
<template>
    <form-group class="form-select" :label-width="labelWidth" :append="show_append" :label="label||(labelOptions?' ': '')">
        <el-select
                slot="labelSelect"
                v-if="labelOptions"
                :value="labelValue"
                :disabled="labelDisabled"
                @change="change_label"
                @input="input_label">
            <el-option v-for="item in labelOptions"
                       :value="item.value"
                       :label="item.label"
                       :key="item.value">
            </el-option>
        </el-select>
        <el-select
                :value="value"
                @change="change_value"
                @input="input_value"
                :disabled="disabled"
                :filterable="filterable"
                :multiple="multiple"
                :collapse-tags="multiple"
                :clearable="clearable">
            <el-option v-for="item in list"
                       :value="item.value"
                       :label="item.label"
                       :key="item.value">
            </el-option>
        </el-select>
        <el-button
                v-if="show_remove"
                slot="append"
                icon="el-icon-close"
                title="Очистить"
                @click="change_value([])">
        </el-button>
        <el-button
                v-if="show_add"
                slot="append"
                icon="el-icon-plus"
                title="Добавить"
                @click="click_add">
        </el-button>
    </form-group>
</template>
